/* eslint-disable */
// hardcoded layer types used for this default config
import {
  WIDGET_TYPE_GQ,
  WIDGET_TYPE_GQ_POI,
  WIDGET_TYPE_POI,
} from '../../constants/layer-types'

const cardConfig = {
  [WIDGET_TYPE_GQ_POI]: [
    {
      "type": "Summary",
      "width": "100%",
      "config": {},
    }
  ],
  [WIDGET_TYPE_GQ]: [
    {
      "id":"1a1ac92c-f443-11e9-9f1d-e5977d5f85f9",
      "type":"Summary",
      "width":"100.00%",
      "config": {
        "summary":{"stat":{"data":{"stat":{"type":"dataKeyPath","value":["personas","P","0","pct_of_total_intersected_population"],"transforms":{"round":{"active":true},"symbol":{"active":true,"params":{"type":"%"}}}}}},"title":{"data":{"title":{"type":"dataKeyPath","value":["personas","P","0","persona_name"]}},"style":{"visibility":"true"}},"label":{"data":{"label":{"type":"manual","value":"% of Pop"}}}}
      },
      "layerID":"polygon"
    },
    {
      "id":"1a1ac92d-f443-11e9-9f1d-e5977d5f85f9",
      "type":"Summary",
      "width":"100.00%",
      "config":
        {"summary":{"stat":{"data":{"stat":{"type":"dataKeyPath","value":["personas","P","1","pct_of_total_intersected_population"],"transforms":{"round":{"active":true},"symbol":{"active":true,"params":{"type":"%"}}}}}},"title":{"data":{"title":{"type":"dataKeyPath","value":["personas","P","1","persona_name"]}},"style":{"visibility":"true"}},"label":{"data":{"label":{"type":"manual","value":"% of Pop"}}}}
      },
      "layerID":"polygon"
    },
  ],
  [WIDGET_TYPE_POI]: [
    {
      "id":"c0b46900-348e-11e9-98ee-53a80b3f9c51",
      "type":"Summary",
      "width":"100%",
      "config":{
        "summary":{
          "stat":{
            "data":{
              "stat":{
                "type":"dataKeyPath",
                "value":["POI Data","visits"],
                transforms:{
                  prettify:{
                    active: true,
                    params: {
                      type: 'number',
                    }
                  }
                }
              }
            }
          },
          "label":{
            "data":{
              "label":{
                "type":"manual","value":"Visits"
              }
            }
          }
        }
      }
    },
    {
      "id":"0e598c50-3492-11e9-8d52-59da46bcc2ee",
      "type":"Tabs",
      "width":"100%",
      "config":{
        "tabElement":{
          "data":{
            "panes":{
              "type":"widgetControl","value":["summary","barChart","barChart","barChart"]
            }
          },
          "paneSummary-0":{
            "stat":{
              "data":{
                "stat":{
                  "type":"dataKeyPath",
                  "value":["POI Data","unique_visitors"],
                  transforms:{
                    prettify:{
                      active: true,
                      params: {
                        type: 'number',
                      }
                    }
                  }
                }
              }
            },
            "label":{
              "data":{
                "label":{
                  "type":"manual","value":"Visitors"
                }
              }
            }
          },
          "paneLabel-0":{"data":{"label":{"type":"manual","value":"Total"}}},
          "paneLabel-1":{"data":{"label":{"type":"manual","value":"Weekly"}}},
          "paneLabel-2":{"data":{"label":{"type":"manual","value":"Hourly"}}},
          "paneLabel-3":{"data":{"label":{"type":"manual","value":"Daily"}}},
          "paneGraph-1":{
            "data":{
              "chartData":{
                "type":"dataKeyPath","value":["Graph Data","Weekly Data"]
              },
              "category": {
                "type": "widgetControl", "value": 'weekStart',
              },
              "dataSets":{
                "type":"widgetControl","value":[{"dataKey":"visits","palette":["#8884d8"]}]
              },
              "shownElements":{"type":"widgetControl","value":{"title":true,"cartesianGrid":false,"categoryAxis":true,"categoryAxisTitle":false,"categoryAxisDetail":true,"valueAxis":false,"valueAxisTitle":true,"valueAxisDetail":true,"tooltip":true,"legend":true, "animation": false}},
              "split":{"type":"widgetControl","value":false}
            }
          },
          "paneGraph-2":{
            "data":{
              "chartData":{
                "type":"dataKeyPath","value":["Graph Data","Hourly Data"]
              },
              "shownElements":{"type":"widgetControl","value":{"title":true,"cartesianGrid":false,"categoryAxis":true,"categoryAxisTitle":false,"categoryAxisDetail":true,"valueAxis":false,"valueAxisTitle":false,"valueAxisDetail":true,"tooltip":true,"legend":true, "animation": false}},
              "dataSets":{
                "type":"widgetControl","value":[{"dataKey":"visits","palette":["#774C70"]}]
              },
              "category": {
                "type": "widgetControl", "value": 'name',
              },
              "split":{"type":"widgetControl","value":false}
            }
          },
          "paneGraph-3":{
            "data":{
              "chartData":{
                "type":"dataKeyPath","value":["Graph Data","Daily Data"]
              },
              "shownElements":{"type":"widgetControl","value":{"title":true,"cartesianGrid":false,"categoryAxis":true,"categoryAxisTitle":false,"categoryAxisDetail":true,"valueAxis":false,"valueAxisTitle":false,"valueAxisDetail":true,"tooltip":true,"legend":true, "animation": false}},
              "split":{ "type":"widgetControl","value":false },
              "category": {
                "type": "widgetControl", "value": 'name',
              },
              "dataSets":{
                "type":"widgetControl","value":[{"dataKey":"visits","palette":["#374C70"]}]
              }
            }
          }
        }
      }
    }
  ],
}

export default cardConfig
